import AntdPhoneInput, { PhoneInputProps } from "antd-phone-input"
import { DEFAULT_COUNTRY } from "utils/constants"

export const PhoneInput = ({ onInput, ...props }: PhoneInputProps) => {
	return (
		<AntdPhoneInput
			{...props}
			disableDropdown
			onlyCountries={[DEFAULT_COUNTRY.toLowerCase()]}
			onInput={(event) => {
				// inserts "1" at the start if not there already
				event.target.value = event.target.value.replace(
					/\+([^1]|$)/,
					(_, ch) => `+1${ch === "$" ? "" : ch}`,
				)
				onInput?.(event)
			}}
		/>
	)
}
